module.exports = __webpack_public_path__ + "img/item_image_3.bc685a7b.jpg";